import { authService, dbService } from "fbase";
import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import Navigation from '../components/Navigation';
import Contact from '../components/Contact';
import { collection, query, orderBy, onSnapshot, where, getDocs } from "firebase/firestore";
import useTitle from "@nooks/use-title";

const Profile = ({userObj, isLoggedIn}) => {
    useTitle("캐리빌리 프로필")
    const navigate = useNavigate();
    const [orderlist, setOrderlist] = useState([]);
    const getMyOrderlist = async() => {
        const q = query(collection(dbService, "orderlist"), where("email", "==", `${userObj.email}`), orderBy("createdTime", "desc"));
        await onSnapshot(q, (snapshot) => {
            const newArray = [];
            snapshot.docs.forEach((doc) => {
                return ( newArray.push({id:doc.id, ...doc.data()}));
            });
            setOrderlist(newArray)
        })
    }
    useEffect(()=>{
        getMyOrderlist();
    }, [userObj])
    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])
    const onLogout = () => {
        authService.signOut()
        navigate("/", {replace:true})
    };
    return (
        <div>
            <Navigation userObj={userObj} isLoggedIn={isLoggedIn} />
            <section className="page-section" id="profile">
                <div className="container">
                    <div className="text-center">
                        <h2 className="section-heading text-uppercase">{userObj.displayName ? `${userObj.displayName}님의 Profile` : "Profile"}</h2>
                    </div>
                    <div className="row text-center">
                        <h2>주문내역</h2>
                    </div>
                </div>
                    {orderlist && orderlist.length > 0 ?
                    orderlist.map((item, index) => 
                    <div className="card px-3 pt-3" style={{maxWidth: "45rem", borderRadius: "1rem", marginBottom: "0.7rem"}} key={item.id}>
                        <Link to={process.env.PUBLIC_URL + `/account/confirm/${item.id}`} style={{color: "black"}}>
                            <div className="row mb-3">
                                <div className="col-6">
                                    <div className="text-info">
                                        <i className="fas fa-plane"></i>
                                        &nbsp; {item.destination ? `${item.destination}` : `${item.nation}_${item.city}`}
                                    </div>
                                </div>
                                <div className="col-6 text-end">
                                    <u>{item.reservDate}~{item.returnDate}</u>
                                </div>
                            </div>
                            <div className="row mb-3">
                                <div className="col-6 text-dark">
                                    <h5>&nbsp;#{index+1}. {item.name}</h5>
                                </div>
                                <div className="col-6 text-end">
                                    <h5 className={item.payment ? "paymentTrue" : "paymentFalse"}>{item.payment ? "입금완료":"입금 전"}</h5>
                                    {item.cnumber}번/{item.size}인치
                                </div>
                            </div>
                        </Link>
                    </div>
                    )                                
                    :
                    (
                        <div className="card px-3 pt-3" style={{maxWidth: "45rem", borderRadius: "1rem", marginBottom: "0.7rem"}}>
                            <div className="row mb-3">
                                <h5>주문 내역이 없습니다...</h5>
                            </div>
                        </div>
                    )
                }
                <div className="container">
                    <div className="row text-center">
                        <h4>입금계좌 _ 농협 302-1739-7182-71 장주영</h4>
                        <div className="logout-btn">
                            <input type="button" className="btn btn-primary btn-xl text-uppercase" onClick={onLogout} value="로그아웃" />
                        </div>
                    </div>
                </div>
            </section>
            <Contact />
        </div>
    )
}
export default Profile;